import { environment } from 'src/environments/environment';

/**
 * Méthode retournant le jwt_bearer_token
 */
export function tokenGetter(): string | null {
  return localStorage.getItem(environment.jwtBearerTokenKey);
}
